import { useIntl } from 'react-intl';
import { SwiperSlide } from 'swiper/react';

import { BlockProgram } from '@/components/BlockProgram';
import { Block, Breakpoints } from '@/types';

import { SwiperBlock } from './SwiperBlock';

export interface BlockProgramProps {
  block: Block;
}

export const CarouselBlock = ({ block }: BlockProgramProps) => {
  const { formatMessage } = useIntl();
  const { items: programs, title } = block;

  return (
    <div className="blocks">
      <h2 className="title">{title}</h2>
      <SwiperBlock
        slidesPerView={3.3}
        slidesPerGroup={3}
        spaceBetween={10}
        slidesOffsetAfter={20}
        slidesOffsetBefore={20}
        freeMode
        navigation
        className="block-swiper"
        breakpoints={{
          [Breakpoints.Small]: {
            slidesPerView: 4.3,
            slidesPerGroup: 4,
          },
          [Breakpoints.Medium]: {
            slidesPerView: 5.3,
            slidesPerGroup: 5,
          },
          [Breakpoints.Large]: {
            slidesPerView: 6.4,
            slidesPerGroup: 6,
          },
          [Breakpoints.ExtraLarge]: {
            slidesPerView: 7.5,
            slidesPerGroup: 6,
          },
        }}
        containerRoleDescriptionMessage={formatMessage(
          { id: 'swiper.accessibility.sliderRole' },
          { title: title }
        )}
      >
        {programs.map((program) => (
          <SwiperSlide key={`high-cover_${program.UUID}`}>
            <BlockProgram program={program} block={block} showTitle showKeyword />
          </SwiperSlide>
        ))}
      </SwiperBlock>
    </div>
  );
};
